import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=21ac55ec&scoped=true&"
import script from "./identification.vue?vue&type=script&lang=js&"
export * from "./identification.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/home.less?vue&type=style&index=0&id=21ac55ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac55ec",
  null
  
)

export default component.exports